import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const Select: Components<Theme> = {
  MuiSelect: {
    defaultProps: {
      IconComponent: ExpandMoreIcon,
    },
    styleOverrides: {
      root: {
        fontWeight: 'bold',
      },
    },
  },
};
